import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { SIZES, TOKENS } from "../consts";
import { rtlSpacing } from "../../utils/rtl";

var getIconSpacing = function getIconSpacing() {
  return function (_ref) {
    var _TOKENS$marginRightIc;

    var theme = _ref.theme,
        right = _ref.right,
        size = _ref.size,
        onlyIcon = _ref.onlyIcon;

    if (onlyIcon) {
      return null;
    }

    var tokens = _defineProperty({}, TOKENS.marginRightIcon, (_TOKENS$marginRightIc = {}, _defineProperty(_TOKENS$marginRightIc, SIZES.LARGE, theme.orbit.marginButtonIconLarge), _defineProperty(_TOKENS$marginRightIc, SIZES.NORMAL, theme.orbit.marginButtonIconNormal), _defineProperty(_TOKENS$marginRightIc, SIZES.SMALL, theme.orbit.marginButtonIconSmall), _TOKENS$marginRightIc));

    return rtlSpacing(right ? "0 0 0 ".concat(tokens[TOKENS.marginRightIcon][size]) : "0 ".concat(tokens[TOKENS.marginRightIcon][size], " 0 0"))({
      theme: theme
    });
  };
};

export default getIconSpacing;